import React from 'react';
import Marquee from "react-fast-marquee";
import './LearningLounge.scss';
import separatorImg from '../../assets/logo/separator.png';
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function MarqueeText({ data }) {
      const authState = useSelector((state) => state.authUser);
      const user_id = authState?.profile?.user_id;
      const user_email = authState?.profile?.email;
    
    return (
        <div className='scrollingBar'>
            <Marquee speed={125} loop={0} pauseOnHover>
                {data.map((item, index) => {
                    return <React.Fragment key={index}>
                        {item?.redirect_url ? <span className='mx-4 px-4' style={{cursor:'pointer'}} onClick={() => { trackEvent('hrd_hub_scroll_text_clicked', 'HRD Hub Scroll Text Clicked', 'HRD Hub Scroll Text Clicked', 1, user_id, user_email); window.open(item?.redirect_url, '_blank', 'noopener') }} title={item.title}>{item.title}</span> : <span className='mx-4 px-4' title={item.title}>{item.title}</span>
                        }
                        {<img style={{ height: '10px' }} src={separatorImg} alt="separator" className='separator' />}
                    </React.Fragment>
                })}
            </Marquee>
        </div>
    )
}

export default MarqueeText
